var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ik-data-table',{ref:"brandingPlan",attrs:{"model":_vm.model,"entity-name":"活动计划"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }